import ArticleLayout from "@/components/feature/ArticleLayout";
import { articles } from "@/mocks/articles";

const article = articles[4];

export default function Artigo() {
  return (
    <ArticleLayout
      title={article.title}
      description={article.excerpt}
      date={article.date}
      readTime={article.readTime}
      imageUrl={article.imageUrl}
      keywords="Yeezy CSSBuy, melhores Yeezy, Yeezy 350 CSSBuy, Yeezy slides, Yeezy China barato"
      articleSchemaName="CSSBuy Spreadsheet"
    >
      <p>
        Os Yeezy continuam a ser dos ténis mais desejados e a nossa <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow">CSSBuy Spreadsheet</a> tem os melhores links atualizados para 2026. Do Yeezy 350 ao Yeezy Slide, temos tudo organizado.
      </p>

      <h2>Modelos Yeezy Disponíveis</h2>
      <p>
        Na planilha encontras links para:
      </p>
      <ul>
        <li><strong>Yeezy 350 V2</strong>: todos os colorways populares</li>
        <li><strong>Yeezy 700</strong>: Wave Runner, Inertia, Analog</li>
        <li><strong>Yeezy Slides</strong>: várias cores disponíveis</li>
        <li><strong>Yeezy Foam Runner</strong>: modelos recentes</li>
        <li><strong>Yeezy 500</strong>: Blush, Utility Black</li>
      </ul>

      <h2>Qualidade dos Yeezy no CSSBuy</h2>
      <p>
        O batch LW é amplamente considerado o melhor para Yeezy 350, com Boost confortável e primeknit de qualidade. Para Yeezy Slides, o batch LW também é o recomendado. Para Yeezy 700, o batch OG oferece o melhor equilíbrio entre preço e qualidade. A nossa planilha indica o batch ideal para cada modelo.
      </p>

      <h2>Como Comprar Yeezy no CSSBuy</h2>
      <p>
        O processo é igual aos outros produtos: escolhe o link na planilha, copia para o CSSBuy, seleciona o tamanho (recomendamos half size up nos Yeezy 350), paga e aguarda o QC. As fotos de QC são essenciais para verificar detalhes como o SPLY-350, shape da sola e qualidade do primeknit.
      </p>
    </ArticleLayout>
  );
}